import { render, staticRenderFns } from "./ComponentSelect.vue?vue&type=template&id=597834e4&scoped=true&"
import script from "./ComponentSelect.vue?vue&type=script&lang=js&"
export * from "./ComponentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597834e4",
  null
  
)

export default component.exports